/**
 * ObjectCell Component
 * 
 * Renders Object/JSON values with:
 * - Key count display: "{3 keys}"
 * - Preview for small objects
 * - Click to expand for full JSON view
 */

import { CellRendererProps } from '../../../../../types/AppPanel';

const MAX_PREVIEW_LENGTH = 35;

export default function ObjectCell({ 
  value, 
  onExpand 
}: CellRendererProps<Record<string, unknown> | null | undefined>) {
  // Handle null/undefined
  if (value === null) {
    return <span className="text-white/30 italic">(null)</span>;
  }
  if (value === undefined) {
    return <span className="text-white/30 italic">(undefined)</span>;
  }
  if (typeof value !== 'object') {
    return <span className="text-white/30 italic">(invalid object)</span>;
  }

  const keys = Object.keys(value);
  
  if (keys.length === 0) {
    return <span className="text-white/30 italic">{'{}'}</span>;
  }

  // Try to show preview for small objects
  const preview = JSON.stringify(value);
  if (preview.length <= MAX_PREVIEW_LENGTH) {
    return (
      <span 
        className="text-white/70 font-mono text-xs cursor-pointer hover:text-[#208AEC] truncate block"
        onClick={onExpand}
        title="Click to expand"
      >
        {preview}
      </span>
    );
  }

  return (
    <button
      onClick={onExpand}
      className="inline-flex items-center gap-1.5 px-2 py-0.5 rounded-full 
                 bg-cyan-500/20 text-cyan-400 text-xs font-medium
                 hover:bg-cyan-500/30 transition-colors cursor-pointer"
      title="Click to view object contents"
    >
      <span className="font-mono">{'{'}</span>
      {keys.length} {keys.length === 1 ? 'key' : 'keys'}
      <span className="font-mono">{'}'}</span>
    </button>
  );
}

